<template>
  <div v-if="data.projects.length" class="p-config-contract-projects">
    <div class="p-config-contract-projects__header l-block__header">
      <TitleSub level="h4">サイト別での利用状況</TitleSub>
    </div>
    <div class="p-config-contract-projects__content">
      <table v-for="project in data.projects" :key="project.id" class="c-table">
        <tbody>
          <tr>
            <th class="bg">
              <strong>{{ project.name }}</strong>
            </th>
          </tr>
          <tr>
            <td>
              <Loading v-if="project.isLoading" variant="inline" />
              <template v-else-if="project.isError">
                利用状況の取得に失敗しました。ページを再読み込みしてください。
              </template>
              <template v-else-if="!Object.keys(project.usages).length">
                -
              </template>
              <div v-else class="l-row l-no-gutters">
                <ul class="p-config-contract-usages l-col">
                  <ListItemUsage
                    v-if="project.usages['competitor-analyses']"
                    label="関連ワード分析回数（月ごと）"
                    :current="project.usages['competitor-analyses'].current"
                    :max="project.usages['competitor-analyses'].max"
                    variant="project"
                  />
                  <ListItemUsage
                    v-if="project.usages['content-plan-keywords']"
                    label="コンテンツ立案調査キーワード登録回数（月ごと）"
                    :current="project.usages['content-plan-keywords'].current"
                    :max="project.usages['content-plan-keywords'].max"
                    variant="project"
                  />
                  <ListItemUsage
                    v-if="project.usages['page-checkups']"
                    label="SEO課題チェック登録回数（月ごと）"
                    :current="project.usages['page-checkups'].current"
                    :max="project.usages['page-checkups'].max"
                    variant="project"
                  />
                  <ListItemUsage
                    v-if="project.usages['competitor-site-analysis']"
                    label="競合キーワード分析回数（月ごと）"
                    :current="
                      project.usages['competitor-site-analysis'].current
                    "
                    :max="project.usages['competitor-site-analysis'].max"
                    variant="project"
                  />
                </ul>
                <ul class="p-config-contract-usages l-col">
                  <ListItemUsage
                    v-if="project.usages['observation-keywords']"
                    label="検索順位キーワード登録数（トータル）"
                    :current="project.usages['observation-keywords'].current"
                    :max="project.usages['observation-keywords'].max"
                    variant="project"
                  />
                  <ListItemUsage
                    v-if="project.usagesCount['observation-keywords']"
                    label="検索順位キーワード登録回数（月ごと）"
                    :current="
                      project.usagesCount['observation-keywords'].current
                    "
                    :max="project.usagesCount['observation-keywords'].max"
                    variant="project-child"
                  />
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ListItemUsage from '@/components/config/ListItemUsage';
import Loading from '@/components/Loading';
import TitleSub from '@/components/TitleSub';
import apiProjects from '@/api/projects';
import axios from 'axios';

export default {
  components: {
    ListItemUsage,
    Loading,
    TitleSub
  },
  data() {
    return {
      cancelTokens: [],
      data: {
        projects: []
      },
      display: [
        'competitor-analyses',
        'content-plan-keywords',
        'observation-keywords',
        'page-checkups',
        'competitor-site-analysis'
      ],
      isLoading: true
    };
  },
  computed: {
    projects() {
      return this.$store.state.user.data.projects;
    }
  },
  created() {
    this.getProjects();
  },
  beforeDestroy() {
    this.cancelTokens.forEach(cancelToken => {
      if (cancelToken) {
        cancelToken.cancel();
      }
    });
  },
  methods: {
    getProjects() {
      this.$store.dispatch('user/getProjects').finally(() => {
        // プロジェクト取得中にページ遷移し、既にコンポーネントが破棄されていたら何もしない
        if (this._isDestroyed) {
          return;
        }

        this.data.projects = this.projects.map(project => {
          return {
            ...project,
            usages: {},
            usagesCount: {},
            isError: false,
            isLoading: true
          };
        });
        this.isLoading = false;

        this.data.projects.forEach((project, index) => {
          Promise.all([
            this.getUsages(project.id, index),
            this.getUsagesCount(project.id, index)
          ])
            .then(() => {
              this.data.projects[index].isLoading = false;
            })
            .catch(error => {
              if (!axios.isCancel(error)) {
                this.data.projects[index].isError = true;
                this.data.projects[index].isLoading = false;
              }
            });
        });
      });
    },
    getUsages(projectId, index) {
      const params = {
        items: 'all'
      };
      const cancelToken = axios.CancelToken.source();
      this.cancelTokens.push(cancelToken);

      return apiProjects.usages
        .get(params, this.auth.idToken, projectId, cancelToken.token)
        .then(response => {
          const usages = response.data.items.reduce((acc, cur) => {
            acc[cur.name] = cur;
            return acc;
          }, {});
          this.data.projects[index].usages = usages;
        });
    },
    getUsagesCount(projectId, index) {
      const params = {
        items: 'observation-keywords'
      };
      const cancelToken = axios.CancelToken.source();
      this.cancelTokens.push(cancelToken);

      return apiProjects.usages.count
        .get(params, this.auth.idToken, projectId, cancelToken.token)
        .then(response => {
          this.data.projects[index].usagesCount[response.data.name] =
            response.data;
        });
    }
  }
};
</script>
